import { Injectable } from '@angular/core';
import { Setor } from '../models/setor';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { ICFeedItem } from '../models/ic/ic-feed-item';
import { NotificacaoService } from './notificacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ICTipoFeedItem } from '../models/enum';

@Injectable({
  providedIn: 'root'
})
export class ICService {

  limiteFeed = 50;

  constructor(
    private http: HttpClient, private notificacaoService: NotificacaoService, private activatedRoute: ActivatedRoute, private router: Router
  ) { }

  salvarFeedItem(feedItem: ICFeedItem) {
    if (feedItem !== null && feedItem !== undefined) {

      if (feedItem.exibirNoFeed) {
        const feedIntegradores = this.buscarFeed();

        feedItem.pendente = true;
        feedItem.dados = JSON.parse(feedItem.payload);

        feedIntegradores.unshift(feedItem);

        this.salvarFeed(feedIntegradores);
      }

      this.notificacaoService.novoICFeedItem.next(feedItem);
    }
  }

  buscarFeed() {
    let jsonFeedIntegradores = localStorage.getItem('feedIntegradores');
    let feedIntegradores: ICFeedItem[] = [];

    if (jsonFeedIntegradores !== null && jsonFeedIntegradores !== undefined && jsonFeedIntegradores.trim() !== '') {
      feedIntegradores = JSON.parse(jsonFeedIntegradores);
    }

    return feedIntegradores;
  }

  salvarFeed(feedIntegradores: ICFeedItem[]) {
    if (feedIntegradores.length > this.limiteFeed) {
      feedIntegradores = feedIntegradores.slice(0, this.limiteFeed);
    }
    localStorage.setItem('feedIntegradores', JSON.stringify(feedIntegradores));
  }

  buscarFeedItemMaisRecente() {
    const feedIntegradores = this.buscarFeed();
    return feedIntegradores.length > 0 ? feedIntegradores[0] : null;
  }

  buscarIntegradores() {
    return this.http.get<any>(globals.apiUrl + '/api/IC/BuscarIntegradores');
  }

  buscarVendedores() {
    return this.http.get<any>(globals.apiUrl + '/api/IC/BuscarVendedores');
  }

  buscarQtdIntegradoresOnline() {
    return this.http.get<number>(globals.apiUrl + '/api/IC/BuscarQtdIntegradoresOnline');
  }

  buscarQtdIntegradoresOffline() {
    return this.http.get<number>(globals.apiUrl + '/api/IC/BuscarQtdIntegradoresOffline');
  }
}
